import { apiLabs } from '../../api'

const OrderCanceled = async (body) => {
	const res = await apiLabs.post('recover_sale/canceled', body)
	return res
}

export default OrderCanceled